import type { IRegionStatistic } from "../../../types/models/regions-statistic"
import { getServerUrl } from "../pages/utils/fetchConfigClient"

export type { IRegionStatistic } from "../../../types/models/regions-statistic"

export async function fetchMetaRegions(): Promise<IRegionStatistic[]> {
  return fetch(getServerUrl(`/meta/regions?t=${new Date().getUTCDate()}`)).then(
    (res) => res.json()
  )
}
